import { lazy } from 'react';

const PotscastList = lazy(() => import('../views/Potscast/PotscastList/PotscastList'));

export const PotscastRoutes = [
  {
    path: '/potscast',
    name: 'Potscast',
    icon: 'mdi mdi-account-key',
    component: PotscastList,
  },
];
